import withAvatarUsuarioDocente from "../../hoc/Avatar/withAvatarUsuarioDocente";
import AvatarUsuario from "../../view/components/Avatar/AvatarUsuario";

export default withAvatarUsuarioDocente(AvatarUsuario);